'use es6';

export default {
  PORTAL: 'portalTz',
  USER: 'userTz',
  UTC: 'utc'
};